// extracted by mini-css-extract-plugin
export default {"category":"Category_category__3GX+F","infoLabel":"Category_infoLabel__BaX7J","required":"Category_required__QeOIw","inputWrapper":"Category_inputWrapper__iEme1"};